module.exports = __webpack_public_path__ + "img/symbol_10_x4.f7686196.png";